/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-this-alias */
// @ts-check

import jQuery from 'jquery';
import angular from 'angular';
import Dialog from './classes/Dialog';
import Action from './classes/Action';

/**
 * RcmDialog
 *  requires:
 *   - Bootstrap v3.3.2 (http://getbootstrap.com) bootstrap.js
 */
const RcmDialog = {
  service: null,

  defaultStrategy: 'rcmBlankDialog',

  /**
   * dialogs
   */
  dialogs: {},

  /**
   * eventManager
   */
  eventManager: {
    events: {},

    on(event, id, method) {
      if (!this.events[event]) {
        this.events[event] = {};
      }

      this.events[event][id] = method;
    },

    trigger(event, args) {
      if (this.events[event]) {
        jQuery.each(this.events[event], function (index, value) {
          value(args);
        });
      }
    },
  },

  /**
   * buildDialogElement - make sure there is an element for dialog
   */
  buildDialogElement() {
    // Check by attribute
    let dialogElm = jQuery('body').find('[data-rcm-dialog]');

    if (dialogElm.length) {
      return;
    }

    // Check by element tag
    dialogElm = jQuery('body').find('data-rcm-dialog');

    if (dialogElm.length) {
      return;
    }

    dialogElm = jQuery('<div data-rcm-dialog="true"></div>');
    jQuery('body').prepend(dialogElm);

    // Compile cant be done if injector not defined
    if (!angular.element(dialogElm).injector()) {
      console.warn('RcmDialog cannot compile data-rcm-dialog element dynmically, angular injector is undefined.');
      return;
    }

    angular
      .element(dialogElm)
      .injector()
      .invoke([
        '$compile',
        function ($compile) {
          const scope = angular.element(dialogElm).scope();
          $compile(dialogElm)(scope);
        },
      ]);
  },

  /**
   * buildId
   *
   * @param id
   * @param url
   * @returns {*}
   */
  buildId(id, url) {
    if (!id) {
      id = url;
    }
    return id;
  },

  /**
   * buildDialog
   *
   * @param id
   * @param title
   * @param url
   * @param strategyName
   * @param actions
   * @param contentscope
   * @returns {*}
   */
  buildDialog(id, title, url, strategyName, actions, contentscope) {
    id = RcmDialog.buildId(id, url);

    if (RcmDialog.hasDialog(id)) {
      RcmDialog.removeDialog(id);
    }

    const dialog = new RcmDialog.dialog();

    if (strategyName) {
      dialog.strategyName = strategyName;
    } else {
      // @ts-ignore FIXME: What???
      dialog.strategyName = new RcmDialog.defaultStrategy();
    }

    dialog.loading = true;

    dialog.id = id;
    dialog.title = title;
    dialog.url = url;

    if (actions) {
      angular.forEach(actions, function (value, key) {
        dialog.setAction(key, value);
      });
    }

    if (contentscope) {
      dialog.contentscope = contentscope;
    }

    RcmDialog.addDialog(dialog);

    return dialog;
  },

  action: Action,

  dialog: Dialog,

  /**
   * addDialog
   *
   * @param dialog
   */
  addDialog(dialog) {
    RcmDialog.dialogs[dialog.id] = dialog;
  },

  /**
   * getDialog
   *
   * @param dialogId
   * @returns {*}
   */
  getDialog(dialogId) {
    return RcmDialog.dialogs[dialogId];
  },

  /**
   * hasDialog
   *
   * @param dialogId
   * @returns bool
   */
  hasDialog(dialogId) {
    return RcmDialog.dialogs[dialogId];
  },

  /**
   * removeDialog
   *
   * @param dialogId
   */
  removeDialog(dialogId) {
    if (!RcmDialog.dialogs[dialogId]) {
      return;
    }
    if (RcmDialog.dialogs[dialogId].elm) {
      RcmDialog.dialogs[dialogId].elm.remove();
      // RcmDialog.dialogs[dialogId].elm.destroy();
      // RcmDialog.dialogs[dialogId].scope.$destroy();
    }
    RcmDialog.dialogs[dialogId] = undefined;
    delete RcmDialog.dialogs[dialogId];
  },
};

export default RcmDialog;

window.RcmDialog = RcmDialog;
